import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { requestV3 } from 'Features/Auth/axios-client'
import { NetworkCapacitiesData } from './Capacities.types'

const fetchNetworkCapacities = async (
  projectId: string,
  scenarioId: string
) => {
  const { data } = await requestV3({
    url: `/network-capacities?projectId=${projectId}&scenarioId=${scenarioId}`,
  })
  return data
}

export const useNetworkCapacities = ({
  projectId,
  scenarioId,
}: {
  projectId: string
  scenarioId: string
}): UseQueryResult<NetworkCapacitiesData[]> => {
  return useQuery({
    queryKey: ['network-capacities', projectId, scenarioId],
    queryFn: () => fetchNetworkCapacities(projectId, scenarioId),
    select: (data) => data.data,
    refetchOnWindowFocus: false,
    gcTime: Infinity,
  })
}
